import React from "react";
import { SectionHeader } from "../components/section-header";
import { Mail } from "lucide-react";
import { NewsletterSignup } from "@/components/features/newsletter/newsletter-signup";

interface WeeklyDigestSectionProps {}

export function WeeklyDigestSection() {
  return (
    <section className="border-b border-border bg-neutral-50/50" aria-labelledby="weekly-digest-heading">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-20">
        <div className="grid gap-16 lg:grid-cols-2 items-center">
          <div>
            <SectionHeader
              eyebrow="Weekly Digest"
              icon={Mail}
              title="Curated Weekly Insights"
            />
            <p className="mt-4 text-muted-foreground leading-relaxed">
              Every week, we bring you the most important stories, discussions, and insights from the HR world. No noise, just signal.
            </p>
            <div className="mt-6 space-y-3">
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-success/10 text-success text-[0.625rem] font-bold">✓</span>
                Top stories curated by our editorial team
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-success/10 text-success text-[0.625rem] font-bold">✓</span>
                Expert analysis and commentary
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-success/10 text-success text-[0.625rem] font-bold">✓</span>
                Upcoming events and opportunities
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="relative w-full max-w-sm">
              <div className="aspect-[4/3] bg-neutral-100 rounded-xl border border-border/50 flex items-center justify-center">
                <div className="text-center">
                  <Mail className="mx-auto h-12 w-12 text-muted-foreground/30 mb-3" />
                  <p className="text-sm text-muted-foreground">Weekly Digest Preview</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}